/** Grid borders for Tasks / Task Templates list tables */

export const taskTableBorderColor = (theme) =>
  theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : theme.palette.divider;

export const taskTableCellBorder = (theme) => `1px solid ${taskTableBorderColor(theme)}`;

export const taskTableOuterBorder = (theme) => `1px solid ${taskTableBorderColor(theme)}`;

const taskTableRowBorderBottom = (theme) => ({
  border: "none",
  borderBottom: taskTableCellBorder(theme),
});

export const taskTableGridTableSx = (bordered = true) => ({
  borderCollapse: "collapse",
  width: "100%",
  "& .MuiTableCell-root": taskTableRowBorderBottom,
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: (theme) =>
      theme.palette.mode === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.025)",
    backgroundImage: "none",
    color: (theme) => theme.palette.text.secondary,
    fontWeight: 700,
    letterSpacing: "0.01em",
    py: 1.4,
    minHeight: 44,
    lineHeight: 1.4,
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    backgroundColor: "background.paper",
    verticalAlign: "middle",
  },
  ...(bordered && {
    "& .MuiTableBody-root tr:last-of-type .MuiTableCell-root": {
      borderBottom: "none",
    },
  }),
});

export const taskTableContainerBorderedSx = {
  "& .MuiTableBody-root tr:last-child td": {
    borderBottom: "none",
  },
};
